import { render, staticRenderFns } from "./ConfigAlertWorkWeChat.vue?vue&type=template&id=0204e26b&scoped=true"
import script from "./ConfigAlertWorkWeChat.vue?vue&type=script&lang=js"
export * from "./ConfigAlertWorkWeChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0204e26b",
  null
  
)

export default component.exports